'use client';

import { useState, useMemo } from 'react';
import Icon from '@/components/ui/AppIcon';
import FilterSidebar from './FilterSidebar';
import ProductGrid from './ProductGrid';
import SearchHeader from './SearchHeader';



export interface Product {
  id: string;
  name: string;
  brand: string;
  model: string;
  price: number;
  originalPrice: number;
  condition: string;
  rating: number;
  reviewCount: number;
  storage: string;
  carrier: string;
  color: string;
  sellerLocation: string;
  sellerRating: number;
  image: string;
  alt: string;
  verified: boolean;
  authenticityBadge: boolean;
  buyerProtection: boolean;
  listedDate: string;
  views: number;
}

export interface FilterOptions {
  brands: string[];
  priceRange: [number, number];
  conditions: string[];
  storage: string[];
  minRating: number;
}

const mockProducts: Product[] = [
{
  id: '1',
  name: 'iPhone 14 Pro Max',
  brand: 'Apple',
  model: 'iPhone 14 Pro Max',
  price: 3899,
  originalPrice: 5299,
  condition: 'Excellent',
  rating: 4.8,
  reviewCount: 156,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Space Black',
  sellerLocation: 'Kuala Lumpur',
  sellerRating: 4.9,
  image: 'https://images.unsplash.com/flagged/photo-1574505544526-22b616c577c2',
  alt: 'Space Black iPhone 14 Pro Max with triple camera system on white background',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-02',
  views: 342
},
{
  id: '2',
  name: 'Samsung Galaxy S23 Ultra',
  brand: 'Samsung',
  model: 'Galaxy S23 Ultra',
  price: 3499,
  originalPrice: 4799,
  condition: 'Like New',
  rating: 4.9,
  reviewCount: 203,
  storage: '512GB',
  carrier: 'Unlocked',
  color: 'Phantom Black',
  sellerLocation: 'Penang',
  sellerRating: 5.0,
  image: "https://images.unsplash.com/photo-1678911820864-e2c567c655d7",
  alt: 'Phantom Black Samsung Galaxy S23 Ultra with S Pen on dark surface',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-03',
  views: 287
},
{
  id: '3',
  name: 'iPhone 13',
  brand: 'Apple',
  model: 'iPhone 13',
  price: 2299,
  originalPrice: 3199,
  condition: 'Good',
  rating: 4.6,
  reviewCount: 94,
  storage: '128GB',
  carrier: 'Unlocked',
  color: 'Pink',
  sellerLocation: 'Johor Bahru',
  sellerRating: 4.7,
  image: 'https://images.unsplash.com/photo-1696234055009-3ae1869a9d1c',
  alt: 'Pink iPhone 13 with dual camera system displayed at angle',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-01',
  views: 421
},
{
  id: '4',
  name: 'Samsung Galaxy S22',
  brand: 'Samsung',
  model: 'Galaxy S22',
  price: 1899,
  originalPrice: 2799,
  condition: 'Excellent',
  rating: 4.7,
  reviewCount: 127,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'White',
  sellerLocation: 'Kuala Lumpur',
  sellerRating: 4.8,
  image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1762078ce-1765620133504.png',
  alt: 'White Samsung Galaxy S22 showing vibrant display screen',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2024-12-30',
  views: 534
},
{
  id: '5',
  name: 'iPhone 12 Pro',
  brand: 'Apple',
  model: 'iPhone 12 Pro',
  price: 1999,
  originalPrice: 2899,
  condition: 'Very Good',
  rating: 4.5,
  reviewCount: 76,
  storage: '128GB',
  carrier: 'Unlocked',
  color: 'Pacific Blue',
  sellerLocation: 'Selangor',
  sellerRating: 4.6,
  image: "https://images.unsplash.com/photo-1603625953337-1232f39f535a",
  alt: 'Pacific Blue iPhone 12 Pro with elegant design and camera array',
  verified: true,
  authenticityBadge: false,
  buyerProtection: true,
  listedDate: '2024-12-28',
  views: 298
},
{
  id: '6',
  name: 'Samsung Galaxy Note 20 Ultra',
  brand: 'Samsung',
  model: 'Galaxy Note 20 Ultra',
  price: 1599,
  originalPrice: 2499,
  condition: 'Good',
  rating: 4.4,
  reviewCount: 52,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Mystic Bronze',
  sellerLocation: 'Penang',
  sellerRating: 4.5,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_14de09140-1767293612677.png",
  alt: 'Mystic Bronze Samsung Galaxy Note 20 Ultra with S Pen stylus',
  verified: false,
  authenticityBadge: false,
  buyerProtection: true,
  listedDate: '2024-12-27',
  views: 187
},
{
  id: '7',
  name: 'iPhone SE (3rd Gen)',
  brand: 'Apple',
  model: 'iPhone SE',
  price: 1299,
  originalPrice: 1899,
  condition: 'Very Good',
  rating: 4.3,
  reviewCount: 89,
  storage: '64GB',
  carrier: 'Unlocked',
  color: 'Midnight',
  sellerLocation: 'Melaka',
  sellerRating: 4.7,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ab8c3783-1765863453730.png",
  alt: 'Midnight iPhone SE showing compact design and home button',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-04',
  views: 145
},
{
  id: '8',
  name: 'Samsung Galaxy A54',
  brand: 'Samsung',
  model: 'Galaxy A54',
  price: 999,
  originalPrice: 1499,
  condition: 'Like New',
  rating: 4.6,
  reviewCount: 112,
  storage: '128GB',
  carrier: 'Unlocked',
  color: 'Awesome Violet',
  sellerLocation: 'Ipoh',
  sellerRating: 4.9,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_14de09140-1767293612677.png",
  alt: 'Awesome Violet Samsung Galaxy A54 with modern design',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-03',
  views: 223
},
{
  id: '9',
  name: 'iPhone 15 Pro',
  brand: 'Apple',
  model: 'iPhone 15 Pro',
  price: 4799,
  originalPrice: 5999,
  condition: 'Like New',
  rating: 4.9,
  reviewCount: 234,
  storage: '512GB',
  carrier: 'Unlocked',
  color: 'Natural Titanium',
  sellerLocation: 'Kuala Lumpur',
  sellerRating: 5.0,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d657f8bd-1766011575905.png",
  alt: 'Natural Titanium iPhone 15 Pro with action button and titanium frame',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-04',
  views: 512
},
{
  id: '10',
  name: 'Samsung Galaxy Z Fold 5',
  brand: 'Samsung',
  model: 'Galaxy Z Fold 5',
  price: 5299,
  originalPrice: 6999,
  condition: 'Excellent',
  rating: 4.8,
  reviewCount: 178,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Icy Blue',
  sellerLocation: 'Penang',
  sellerRating: 4.9,
  image: "https://images.unsplash.com/photo-1692647494155-ee2df7cf2869",
  alt: 'Icy Blue Samsung Galaxy Z Fold 5 unfolded showing large display',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-03',
  views: 389
},
{
  id: '11',
  name: 'Google Pixel 8 Pro',
  brand: 'Google',
  model: 'Pixel 8 Pro',
  price: 3199,
  originalPrice: 4299,
  condition: 'Excellent',
  rating: 4.7,
  reviewCount: 145,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Bay Blue',
  sellerLocation: 'Selangor',
  sellerRating: 4.8,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1d82a15-1766527795297.png",
  alt: 'Bay Blue Google Pixel 8 Pro with advanced camera system',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-02',
  views: 267
},
{
  id: '12',
  name: 'iPhone 11',
  brand: 'Apple',
  model: 'iPhone 11',
  price: 1499,
  originalPrice: 2299,
  condition: 'Good',
  rating: 4.4,
  reviewCount: 198,
  storage: '64GB',
  carrier: 'Celcom',
  color: 'Purple',
  sellerLocation: 'Johor Bahru',
  sellerRating: 4.6,
  image: "https://images.unsplash.com/photo-1683963137634-c961760bbd5c",
  alt: 'Purple iPhone 11 with dual camera system',
  verified: true,
  authenticityBadge: false,
  buyerProtection: true,
  listedDate: '2024-12-29',
  views: 456
},
{
  id: '13',
  name: 'Samsung Galaxy S21 FE',
  brand: 'Samsung',
  model: 'Galaxy S21 FE',
  price: 1399,
  originalPrice: 2099,
  condition: 'Very Good',
  rating: 4.5,
  reviewCount: 167,
  storage: '128GB',
  carrier: 'Unlocked',
  color: 'Lavender',
  sellerLocation: 'Kuching',
  sellerRating: 4.7,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c2e934be-1765615223395.png",
  alt: 'Lavender Samsung Galaxy S21 FE with sleek design',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-01',
  views: 312
},
{
  id: '14',
  name: 'OnePlus 11',
  brand: 'OnePlus',
  model: 'OnePlus 11',
  price: 2399,
  originalPrice: 3299,
  condition: 'Like New',
  rating: 4.6,
  reviewCount: 89,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Eternal Green',
  sellerLocation: 'Kota Kinabalu',
  sellerRating: 4.8,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c9a7c7b6-1767529494953.png",
  alt: 'Eternal Green OnePlus 11 with Hasselblad camera system',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-03',
  views: 201
},
{
  id: '15',
  name: 'iPhone 14',
  brand: 'Apple',
  model: 'iPhone 14',
  price: 3099,
  originalPrice: 4199,
  condition: 'Excellent',
  rating: 4.7,
  reviewCount: 213,
  storage: '128GB',
  carrier: 'U Mobile',
  color: 'Blue',
  sellerLocation: 'Kuala Lumpur',
  sellerRating: 4.9,
  image: "https://images.unsplash.com/photo-1675296844307-10fb39cc03d6",
  alt: 'Blue iPhone 14 with advanced dual camera system',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-04',
  views: 378
},
{
  id: '16',
  name: 'Xiaomi 13 Pro',
  brand: 'Xiaomi',
  model: 'Xiaomi 13 Pro',
  price: 2199,
  originalPrice: 3099,
  condition: 'Very Good',
  rating: 4.6,
  reviewCount: 134,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Ceramic White',
  sellerLocation: 'Ipoh',
  sellerRating: 4.7,
  image: "https://images.unsplash.com/photo-1687331780289-f2bec66a0550",
  alt: 'Ceramic White Xiaomi 13 Pro with Leica camera system',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-02',
  views: 245
},
{
  id: '17',
  name: 'Samsung Galaxy A73',
  brand: 'Samsung',
  model: 'Galaxy A73',
  price: 1199,
  originalPrice: 1799,
  condition: 'Good',
  rating: 4.4,
  reviewCount: 98,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Awesome Mint',
  sellerLocation: 'Melaka',
  sellerRating: 4.6,
  image: 'https://images.unsplash.com/photo-1678911820864-e2c567c655d7',
  alt: 'Awesome Mint Samsung Galaxy A73 with quad camera setup',
  verified: false,
  authenticityBadge: false,
  buyerProtection: true,
  listedDate: '2024-12-31',
  views: 189
},
{
  id: '18',
  name: 'iPhone 13 Pro Max',
  brand: 'Apple',
  model: 'iPhone 13 Pro Max',
  price: 3399,
  originalPrice: 4699,
  condition: 'Excellent',
  rating: 4.8,
  reviewCount: 267,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Sierra Blue',
  sellerLocation: 'Penang',
  sellerRating: 5.0,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_105ee26ea-1766777665198.png",
  alt: 'Sierra Blue iPhone 13 Pro Max with triple camera system and ProMotion display',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-03',
  views: 423
},
{
  id: '19',
  name: 'Google Pixel 7',
  brand: 'Google',
  model: 'Pixel 7',
  price: 1799,
  originalPrice: 2599,
  condition: 'Very Good',
  rating: 4.5,
  reviewCount: 112,
  storage: '128GB',
  carrier: 'Unlocked',
  color: 'Lemongrass',
  sellerLocation: 'Selangor',
  sellerRating: 4.7,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_110c67ed8-1767515488937.png",
  alt: 'Lemongrass Google Pixel 7 with Google Tensor G2 chip',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-01',
  views: 298
},
{
  id: '20',
  name: 'Samsung Galaxy Z Flip 5',
  brand: 'Samsung',
  model: 'Galaxy Z Flip 5',
  price: 3699,
  originalPrice: 4799,
  condition: 'Like New',
  rating: 4.7,
  reviewCount: 156,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Mint',
  sellerLocation: 'Kuala Lumpur',
  sellerRating: 4.9,
  image: "https://images.unsplash.com/photo-1692647494155-ee2df7cf2869",
  alt: 'Mint Samsung Galaxy Z Flip 5 in compact folded form',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-04',
  views: 334
},
{
  id: '21',
  name: 'Oppo Find X5 Pro',
  brand: 'Oppo',
  model: 'Find X5 Pro',
  price: 1899,
  originalPrice: 2799,
  condition: 'Excellent',
  rating: 4.6,
  reviewCount: 87,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Glaze Black',
  sellerLocation: 'Johor Bahru',
  sellerRating: 4.8,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b8eada96-1764662825753.png",
  alt: 'Glaze Black Oppo Find X5 Pro with Hasselblad camera',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-02',
  views: 223
},
{
  id: '25',
  name: 'Oppo Reno 10 Pro+',
  brand: 'Oppo',
  model: 'Reno 10 Pro+',
  price: 1599,
  originalPrice: 2299,
  condition: 'Like New',
  rating: 4.7,
  reviewCount: 124,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Silvery Grey',
  sellerLocation: 'Kuala Lumpur',
  sellerRating: 4.9,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_12bdadc09-1765619941140.png",
  alt: 'Silvery Grey Oppo Reno 10 Pro+ with telephoto portrait camera',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-05',
  views: 189
},
{
  id: '26',
  name: 'Oppo Find N3',
  brand: 'Oppo',
  model: 'Find N3',
  price: 3299,
  originalPrice: 4499,
  condition: 'Excellent',
  rating: 4.8,
  reviewCount: 98,
  storage: '512GB',
  carrier: 'Unlocked',
  color: 'Gold',
  sellerLocation: 'Penang',
  sellerRating: 5.0,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a65bdfb5-1766490604476.png",
  alt: 'Gold Oppo Find N3 foldable smartphone with large display',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-04',
  views: 267
},
{
  id: '27',
  name: 'Oppo Reno 8 Pro',
  brand: 'Oppo',
  model: 'Reno 8 Pro',
  price: 1199,
  originalPrice: 1799,
  condition: 'Very Good',
  rating: 4.5,
  reviewCount: 156,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Glazed Black',
  sellerLocation: 'Selangor',
  sellerRating: 4.7,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b13011c6-1767680571118.png",
  alt: 'Glazed Black Oppo Reno 8 Pro with MariSilicon X imaging chip',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-03',
  views: 198
},
{
  id: '28',
  name: 'Oppo A98 5G',
  brand: 'Oppo',
  model: 'A98 5G',
  price: 799,
  originalPrice: 1199,
  condition: 'Like New',
  rating: 4.4,
  reviewCount: 87,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Cool Black',
  sellerLocation: 'Ipoh',
  sellerRating: 4.6,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c7b7f190-1767680570569.png",
  alt: 'Cool Black Oppo A98 5G with 67W SUPERVOOC charging',
  verified: true,
  authenticityBadge: false,
  buyerProtection: true,
  listedDate: '2025-01-06',
  views: 145
},
{
  id: '29',
  name: 'Oppo Find X6 Pro',
  brand: 'Oppo',
  model: 'Find X6 Pro',
  price: 2499,
  originalPrice: 3499,
  condition: 'Excellent',
  rating: 4.9,
  reviewCount: 112,
  storage: '512GB',
  carrier: 'Unlocked',
  color: 'Desert Silver',
  sellerLocation: 'Johor Bahru',
  sellerRating: 4.9,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b8eada96-1764662825753.png",
  alt: 'Desert Silver Oppo Find X6 Pro with Hasselblad triple camera system',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-05',
  views: 234
},
{
  id: '30',
  name: 'Oppo Reno 11 Pro',
  brand: 'Oppo',
  model: 'Reno 11 Pro',
  price: 1399,
  originalPrice: 1999,
  condition: 'Like New',
  rating: 4.6,
  reviewCount: 94,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Rock Grey',
  sellerLocation: 'Kuala Lumpur',
  sellerRating: 4.8,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_115e250fc-1767680570571.png",
  alt: 'Rock Grey Oppo Reno 11 Pro with curved AMOLED display',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-06',
  views: 176
},
{
  id: '31',
  name: 'Huawei P60 Pro',
  brand: 'Huawei',
  model: 'P60 Pro',
  price: 2899,
  originalPrice: 3999,
  condition: 'Excellent',
  rating: 4.8,
  reviewCount: 142,
  storage: '512GB',
  carrier: 'Unlocked',
  color: 'Rococo Pearl',
  sellerLocation: 'Kuala Lumpur',
  sellerRating: 4.9,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_107d28050-1764808697807.png",
  alt: 'Rococo Pearl Huawei P60 Pro with advanced XMAGE camera system',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-05',
  views: 298
},
{
  id: '32',
  name: 'Huawei Mate 60 Pro',
  brand: 'Huawei',
  model: 'Mate 60 Pro',
  price: 3299,
  originalPrice: 4499,
  condition: 'Like New',
  rating: 4.9,
  reviewCount: 187,
  storage: '512GB',
  carrier: 'Unlocked',
  color: 'Black',
  sellerLocation: 'Penang',
  sellerRating: 5.0,
  image: "https://images.unsplash.com/photo-1733924307395-9bfc5b46fb89",
  alt: 'Black Huawei Mate 60 Pro with satellite communication capability',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-06',
  views: 412
},
{
  id: '33',
  name: 'Huawei Nova 11 Pro',
  brand: 'Huawei',
  model: 'Nova 11 Pro',
  price: 1599,
  originalPrice: 2299,
  condition: 'Excellent',
  rating: 4.6,
  reviewCount: 98,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Green',
  sellerLocation: 'Johor Bahru',
  sellerRating: 4.8,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c95dae95-1766535935456.png",
  alt: 'Green Huawei Nova 11 Pro with dual front camera setup',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-04',
  views: 234
},
{
  id: '34',
  name: 'Huawei Pura 70 Ultra',
  brand: 'Huawei',
  model: 'Pura 70 Ultra',
  price: 3799,
  originalPrice: 4999,
  condition: 'Like New',
  rating: 4.9,
  reviewCount: 156,
  storage: '512GB',
  carrier: 'Unlocked',
  color: 'Green',
  sellerLocation: 'Selangor',
  sellerRating: 4.9,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1932a20dd-1767681103250.png",
  alt: 'Green Huawei Pura 70 Ultra with retractable camera lens',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-06',
  views: 367
},
{
  id: '35',
  name: 'Huawei Mate X5',
  brand: 'Huawei',
  model: 'Mate X5',
  price: 5299,
  originalPrice: 6999,
  condition: 'Excellent',
  rating: 4.8,
  reviewCount: 124,
  storage: '512GB',
  carrier: 'Unlocked',
  color: 'Gold',
  sellerLocation: 'Kuala Lumpur',
  sellerRating: 5.0,
  image: "https://images.unsplash.com/photo-1609388449530-4a666d200cad",
  alt: 'Gold Huawei Mate X5 foldable smartphone with large display',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-05',
  views: 489
},
{
  id: '36',
  name: 'Huawei P50 Pro',
  brand: 'Huawei',
  model: 'P50 Pro',
  price: 1899,
  originalPrice: 2799,
  condition: 'Very Good',
  rating: 4.7,
  reviewCount: 167,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Golden Black',
  sellerLocation: 'Ipoh',
  sellerRating: 4.7,
  image: "https://images.unsplash.com/photo-1729514358644-4aba4832f2f9",
  alt: 'Golden Black Huawei P50 Pro with dual-matrix camera design',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-03',
  views: 278
},
{
  id: '37',
  name: 'Huawei Nova Y91',
  brand: 'Huawei',
  model: 'Nova Y91',
  price: 799,
  originalPrice: 1199,
  condition: 'Good',
  rating: 4.4,
  reviewCount: 89,
  storage: '128GB',
  carrier: 'Unlocked',
  color: 'Starry Black',
  sellerLocation: 'Melaka',
  sellerRating: 4.6,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f137f0ec-1767681104885.png",
  alt: 'Starry Black Huawei Nova Y91 with large battery capacity',
  verified: true,
  authenticityBadge: false,
  buyerProtection: true,
  listedDate: '2025-01-02',
  views: 156
},
{
  id: '38',
  name: 'Huawei Mate 50 Pro',
  brand: 'Huawei',
  model: 'Mate 50 Pro',
  price: 2499,
  originalPrice: 3499,
  condition: 'Excellent',
  rating: 4.8,
  reviewCount: 178,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Silver',
  sellerLocation: 'Penang',
  sellerRating: 4.9,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_107d28050-1764808697807.png",
  alt: 'Silver Huawei Mate 50 Pro with XMAGE imaging technology',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-04',
  views: 312
},
{
  id: '39',
  name: 'Huawei Nova 12 Pro',
  brand: 'Huawei',
  model: 'Nova 12 Pro',
  price: 1799,
  originalPrice: 2499,
  condition: 'Like New',
  rating: 4.7,
  reviewCount: 134,
  storage: '512GB',
  carrier: 'Unlocked',
  color: 'White',
  sellerLocation: 'Kuching',
  sellerRating: 4.8,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_16f00064f-1767681108373.png",
  alt: 'White Huawei Nova 12 Pro with portrait photography features',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-05',
  views: 245
},
{
  id: '40',
  name: 'Huawei P40 Pro',
  brand: 'Huawei',
  model: 'P40 Pro',
  price: 1299,
  originalPrice: 1999,
  condition: 'Good',
  rating: 4.5,
  reviewCount: 201,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Silver Frost',
  sellerLocation: 'Kota Kinabalu',
  sellerRating: 4.7,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1eb4f72a2-1767681103260.png",
  alt: 'Silver Frost Huawei P40 Pro with Leica quad camera system',
  verified: true,
  authenticityBadge: false,
  buyerProtection: true,
  listedDate: '2025-01-01',
  views: 189
},
{
  id: '22',
  name: 'iPhone 12',
  brand: 'Apple',
  model: 'iPhone 12',
  price: 1699,
  originalPrice: 2499,
  condition: 'Good',
  rating: 4.5,
  reviewCount: 189,
  storage: '128GB',
  carrier: 'Unlocked',
  color: 'Green',
  sellerLocation: 'Kuching',
  sellerRating: 4.6,
  image: "https://images.unsplash.com/photo-1605604365645-9723b27e829b",
  alt: 'Green iPhone 12 with dual camera system and 5G capability',
  verified: true,
  authenticityBadge: false,
  buyerProtection: true,
  listedDate: '2024-12-30',
  views: 367
},
{
  id: '23',
  name: 'Vivo X90 Pro',
  brand: 'Vivo',
  model: 'X90 Pro',
  price: 2599,
  originalPrice: 3499,
  condition: 'Like New',
  rating: 4.7,
  reviewCount: 76,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Legendary Black',
  sellerLocation: 'Kota Kinabalu',
  sellerRating: 4.8,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_13439d222-1765141907611.png",
  alt: 'Legendary Black Vivo X90 Pro with Zeiss optics',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-03',
  views: 198
},
{
  id: '24',
  name: 'Samsung Galaxy S23',
  brand: 'Samsung',
  model: 'Galaxy S23',
  price: 2699,
  originalPrice: 3599,
  condition: 'Excellent',
  rating: 4.8,
  reviewCount: 201,
  storage: '256GB',
  carrier: 'Unlocked',
  color: 'Cream',
  sellerLocation: 'Penang',
  sellerRating: 4.9,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c24c4fe4-1764862789275.png",
  alt: 'Cream Samsung Galaxy S23 with compact flagship design',
  verified: true,
  authenticityBadge: true,
  buyerProtection: true,
  listedDate: '2025-01-04',
  views: 289
}];


type SortOption = 'price-low' | 'price-high' | 'newest' | 'rating' | 'distance' | 'condition';
type ViewMode = 'grid' | 'list';

const BrowseProductsInteractive = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const [sortBy, setSortBy] = useState<SortOption>('newest');
  const [viewMode, setViewMode] = useState<ViewMode>('grid');

  const [filters, setFilters] = useState<FilterOptions>({
    brands: [],
    priceRange: [0, 7000],
    conditions: [],
    storage: [],
    minRating: 0
  });

  const filteredAndSortedProducts = useMemo(() => {
    let results = mockProducts.filter((product) => {
      const matchesSearch =
      searchQuery === '' ||
      product?.name?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
      product?.brand?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
      product?.model?.toLowerCase()?.includes(searchQuery.toLowerCase());

      const matchesBrand = filters.brands.length === 0 || filters.brands.includes(product.brand);
      const matchesPrice = product.price >= filters.priceRange[0] && product.price <= filters.priceRange[1];
      const matchesCondition = filters.conditions.length === 0 || filters.conditions.includes(product.condition);
      const matchesStorage = filters.storage.length === 0 || filters.storage.includes(product.storage);
      const matchesRating = product.rating >= filters.minRating;

      return matchesSearch && matchesBrand && matchesPrice && matchesCondition &&
      matchesStorage && matchesRating;
    });

    // Sort results
    results.sort((a, b) => {
      switch (sortBy) {
        case 'price-low':
          return a.price - b.price;
        case 'price-high':
          return b.price - a.price;
        case 'newest':
          return new Date(b.listedDate).getTime() - new Date(a.listedDate).getTime();
        case 'rating':
          return b.rating - a.rating;
        case 'condition':
          const conditionOrder: {[key: string]: number;} = {
            'Like New': 0, 'Excellent': 1, 'Very Good': 2, 'Good': 3
          };
          return (conditionOrder[a.condition] || 999) - (conditionOrder[b.condition] || 999);
        default:
          return 0;
      }
    });

    return results;
  }, [searchQuery, filters, sortBy]);

  const handleFilterChange = (newFilters: Partial<FilterOptions>) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  };

  const handleClearFilters = () => {
    setFilters({
      brands: [],
      priceRange: [0, 7000],
      conditions: [],
      storage: [],
      minRating: 0
    });
    setSearchQuery('');
  };

  const activeFilterCount =
  filters.brands.length +
  filters.conditions.length +
  filters.storage.length + (
  filters.minRating > 0 ? 1 : 0);

  return (
    <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1047:4" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1047" data-component-end-line="1206" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-screen%20bg-background%22%7D" className="min-h-screen bg-background">
      <SearchHeader data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1048:6" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1048" data-component-end-line="1048" data-component-file="BrowseProductsInteractive.tsx" data-component-name="SearchHeader" data-component-content="%7B%22elementName%22%3A%22SearchHeader%22%7D" />

      <main data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1050:6" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1050" data-component-end-line="1171" data-component-file="BrowseProductsInteractive.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22container%20mx-auto%20px-4%20py-8%22%7D" className="container mx-auto px-4 py-8">
        <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1051:8" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1051" data-component-end-line="1170" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-6%22%7D" className="flex gap-6">
          {/* Filter Sidebar */}
          <aside data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1053:10" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1053" data-component-end-line="1061" data-component-file="BrowseProductsInteractive.tsx" data-component-name="aside" data-component-content="%7B%22elementName%22%3A%22aside%22%2C%22className%22%3A%22w-72%22%7D" className="w-72">
            <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1054:12" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1054" data-component-end-line="1060" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22sticky%20top-4%22%7D" className="sticky top-4">
              <FilterSidebar data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1055:14" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1055" data-component-end-line="1059" data-component-file="BrowseProductsInteractive.tsx" data-component-name="FilterSidebar" data-component-content="%7B%22elementName%22%3A%22FilterSidebar%22%7D"
                filters={filters}
                onFilterChange={handleFilterChange}
                onClearFilters={handleClearFilters}
                activeFilterCount={activeFilterCount} />
            </div>
          </aside>

          {/* Main Content */}
          <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1064:10" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1064" data-component-end-line="1169" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%22%7D" className="flex-1">
            {/* Toolbar */}
            <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1066:12" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1066" data-component-end-line="1123" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-6%20flex%20flex-wrap%20items-center%20justify-between%20gap-4%20rounded-xl%20border%20border-border%20bg-card%20p-4%22%7D" className="mb-6 flex flex-wrap items-center justify-between gap-4 rounded-xl border border-border bg-card p-4">
              <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1067:14" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1067" data-component-end-line="1084" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-4%22%7D" className="flex items-center gap-4">
                <button data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1068:16" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1068" data-component-end-line="1079" data-component-file="BrowseProductsInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22flex%20items-center%20gap-2%20rounded-lg%20border%20border-border%20bg-background%20px-4%20py-2%20font-medium%20text-foreground%20transition-smooth%20hover%3Abg-muted%20focus-ring%20lg%3Ahidden%22%7D"
                  onClick={() => setIsMobileFilterOpen(true)}
                  className="flex items-center gap-2 rounded-lg border border-border bg-background px-4 py-2 font-medium text-foreground transition-smooth hover:bg-muted focus-ring lg:hidden">

                  <Icon data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1072:18" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1072" data-component-end-line="1072" data-component-file="BrowseProductsInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22AdjustmentsHorizontalIcon%22%7D" name="AdjustmentsHorizontalIcon" size={20} />
                  <span data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1073:18" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1073" data-component-end-line="1073" data-component-file="BrowseProductsInteractive.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22Filters%22%7D">Filters</span>
                  {activeFilterCount > 0 &&
                  <span data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1075:18" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1075" data-component-end-line="1077" data-component-file="BrowseProductsInteractive.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22flex%20h-5%20w-5%20items-center%20justify-center%20rounded-full%20bg-primary%20text-xs%20font-bold%20text-primary-foreground%22%7D" className="flex h-5 w-5 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground">
                      {activeFilterCount}
                    </span>
                  }
                </button>

                <p data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1081:16" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1081" data-component-end-line="1083" data-component-file="BrowseProductsInteractive.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%22%2C%22textContent%22%3A%22results%20found%22%7D" className="text-sm text-muted-foreground">
                  <span data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1082:18" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1082" data-component-end-line="1082" data-component-file="BrowseProductsInteractive.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-semibold%20text-foreground%22%7D" className="font-semibold text-foreground">{filteredAndSortedProducts.length}</span> results found
                </p>
              </div>

              <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1086:14" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1086" data-component-end-line="1122" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-4%22%7D" className="flex items-center gap-4">
                {/* View Mode Toggle */}
                <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1088:16" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1088" data-component-end-line="1107" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20items-center%20gap-1%20rounded-lg%20border%20border-border%20bg-background%20p-1%20sm%3Aflex%22%7D" className="hidden items-center gap-1 rounded-lg border border-border bg-background p-1 sm:flex">
                  <button data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1089:18" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1089" data-component-end-line="1097" data-component-file="BrowseProductsInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
                    onClick={() => setViewMode('grid')}
                    className={`rounded p-2 transition-smooth focus-ring ${
                    viewMode === 'grid' ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-muted'}`
                    }
                    aria-label="Grid view">

                    <Icon data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1096:20" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1096" data-component-end-line="1096" data-component-file="BrowseProductsInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22Squares2X2Icon%22%7D" name="Squares2X2Icon" size={18} />
                  </button>
                  <button data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1098:18" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1098" data-component-end-line="1106" data-component-file="BrowseProductsInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
                    onClick={() => setViewMode('list')}
                    className={`rounded p-2 transition-smooth focus-ring ${
                    viewMode === 'list' ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-muted'}`
                    }
                    aria-label="List view">

                    <Icon data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1105:20" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1105" data-component-end-line="1105" data-component-file="BrowseProductsInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ListBulletIcon%22%7D" name="ListBulletIcon" size={18} />
                  </button>
                </div>

                {/* Sort Dropdown */}
                <select data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1110:16" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1110" data-component-end-line="1121" data-component-file="BrowseProductsInteractive.tsx" data-component-name="select" data-component-content="%7B%22elementName%22%3A%22select%22%2C%22value%22%3A%22%5Bvar%3AsortBy%5D%22%2C%22className%22%3A%22rounded-lg%20border%20border-border%20bg-background%20px-4%20py-2%20font-medium%20text-foreground%20transition-smooth%20hover%3Abg-muted%20focus-ring%22%7D"
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value as SortOption)}
                  className="rounded-lg border border-border bg-background px-4 py-2 font-medium text-foreground transition-smooth hover:bg-muted focus-ring">

                  <option data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1115:18" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1115" data-component-end-line="1115" data-component-file="BrowseProductsInteractive.tsx" data-component-name="option" data-component-content="%7B%22elementName%22%3A%22option%22%2C%22value%22%3A%22newest%22%2C%22textContent%22%3A%22Newest%20First%22%7D" value="newest">Newest First</option>
                  <option data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1116:18" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1116" data-component-end-line="1116" data-component-file="BrowseProductsInteractive.tsx" data-component-name="option" data-component-content="%7B%22elementName%22%3A%22option%22%2C%22value%22%3A%22price-low%22%2C%22textContent%22%3A%22Price%3A%20Low%20to%20High%22%7D" value="price-low">Price: Low to High</option>
                  <option data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1117:18" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1117" data-component-end-line="1117" data-component-file="BrowseProductsInteractive.tsx" data-component-name="option" data-component-content="%7B%22elementName%22%3A%22option%22%2C%22value%22%3A%22price-high%22%2C%22textContent%22%3A%22Price%3A%20High%20to%20Low%22%7D" value="price-high">Price: High to Low</option>
                  <option data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1118:18" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1118" data-component-end-line="1118" data-component-file="BrowseProductsInteractive.tsx" data-component-name="option" data-component-content="%7B%22elementName%22%3A%22option%22%2C%22value%22%3A%22rating%22%2C%22textContent%22%3A%22Highest%20Rated%22%7D" value="rating">Highest Rated</option>
                  <option data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1119:18" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1119" data-component-end-line="1119" data-component-file="BrowseProductsInteractive.tsx" data-component-name="option" data-component-content="%7B%22elementName%22%3A%22option%22%2C%22value%22%3A%22condition%22%2C%22textContent%22%3A%22Best%20Condition%22%7D" value="condition">Best Condition</option>
                  <option data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1120:18" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1120" data-component-end-line="1120" data-component-file="BrowseProductsInteractive.tsx" data-component-name="option" data-component-content="%7B%22elementName%22%3A%22option%22%2C%22value%22%3A%22distance%22%2C%22textContent%22%3A%22Nearest%20Location%22%7D" value="distance">Nearest Location</option>
                </select>
              </div>
            </div>

            {/* Active Filters Display */}
            {activeFilterCount > 0 &&
            <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1127:12" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1127" data-component-end-line="1164" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-6%20flex%20flex-wrap%20items-center%20gap-2%22%7D" className="mb-6 flex flex-wrap items-center gap-2">
                {filters.brands.map((brand) =>
              <span data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1129:14" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1129" data-component-end-line="1140" data-component-file="BrowseProductsInteractive.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22inline-flex%20items-center%20gap-2%20rounded-lg%20bg-primary%2F10%20px-3%20py-1%20text-sm%20font-medium%20text-primary%22%7D"
                key={brand}
                className="inline-flex items-center gap-2 rounded-lg bg-primary/10 px-3 py-1 text-sm font-medium text-primary">

                    {brand}
                    <button data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1134:20" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1134" data-component-end-line="1139" data-component-file="BrowseProductsInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22transition-smooth%20hover%3Aopacity-70%22%7D"
                  onClick={() => handleFilterChange({ brands: filters.brands.filter((b) => b !== brand) })}
                  className="transition-smooth hover:opacity-70">

                      <Icon data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1138:22" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1138" data-component-end-line="1138" data-component-file="BrowseProductsInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22XMarkIcon%22%7D" name="XMarkIcon" size={14} />
                    </button>
                  </span>
              )}
                {filters.conditions.map((condition) =>
              <span data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1143:14" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1143" data-component-end-line="1154" data-component-file="BrowseProductsInteractive.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22inline-flex%20items-center%20gap-2%20rounded-lg%20bg-primary%2F10%20px-3%20py-1%20text-sm%20font-medium%20text-primary%22%7D"
                key={condition}
                className="inline-flex items-center gap-2 rounded-lg bg-primary/10 px-3 py-1 text-sm font-medium text-primary">

                    {condition}
                    <button data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1148:20" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1148" data-component-end-line="1153" data-component-file="BrowseProductsInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22transition-smooth%20hover%3Aopacity-70%22%7D"
                  onClick={() => handleFilterChange({ conditions: filters.conditions.filter((c) => c !== condition) })}
                  className="transition-smooth hover:opacity-70">

                      <Icon data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1152:22" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1152" data-component-end-line="1152" data-component-file="BrowseProductsInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22XMarkIcon%22%7D" name="XMarkIcon" size={14} />
                    </button>
                  </span>
              )}
                {activeFilterCount > 0 &&
              <button data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1157:14" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1157" data-component-end-line="1162" data-component-file="BrowseProductsInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22text-sm%20font-medium%20text-destructive%20transition-smooth%20hover%3Aunderline%22%2C%22textContent%22%3A%22Clear%20all%20filters%22%7D"
                onClick={handleClearFilters}
                className="text-sm font-medium text-destructive transition-smooth hover:underline">

                    Clear all filters
                  </button>
              }
              </div>
            }

            {/* Product Grid/List */}
            <ProductGrid data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1168:12" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1168" data-component-end-line="1168" data-component-file="BrowseProductsInteractive.tsx" data-component-name="ProductGrid" data-component-content="%7B%22elementName%22%3A%22ProductGrid%22%7D" products={filteredAndSortedProducts} viewMode={viewMode} />
          </div>
        </div>
      </main>

      {/* Mobile Filter Drawer */}
      {isMobileFilterOpen &&
      <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1175:6" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1175" data-component-end-line="1204" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20z-50%20lg%3Ahidden%22%7D" className="fixed inset-0 z-50 lg:hidden">
          <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1176:10" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1176" data-component-end-line="1176" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-black%2F50%22%7D" className="absolute inset-0 bg-black/50" onClick={() => setIsMobileFilterOpen(false)} />
          <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1177:10" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1177" data-component-end-line="1203" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20right-0%20top-0%20h-full%20w-full%20max-w-sm%20overflow-y-auto%20bg-card%20shadow-elevation-3%20sm%3Aw-96%22%7D" className="absolute right-0 top-0 h-full w-full max-w-sm overflow-y-auto bg-card shadow-elevation-3 sm:w-96">
            <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1178:12" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1178" data-component-end-line="1186" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22sticky%20top-0%20z-10%20flex%20items-center%20justify-between%20border-b%20border-border%20bg-card%20p-4%22%7D" className="sticky top-0 z-10 flex items-center justify-between border-b border-border bg-card p-4">
              <h2 data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1179:14" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1179" data-component-end-line="1179" data-component-file="BrowseProductsInteractive.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-lg%20font-semibold%20text-foreground%22%2C%22textContent%22%3A%22Filters%22%7D" className="text-lg font-semibold text-foreground">Filters</h2>
              <button data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1180:14" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1180" data-component-end-line="1185" data-component-file="BrowseProductsInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22flex%20h-10%20w-10%20items-center%20justify-center%20rounded-lg%20text-foreground%20transition-smooth%20hover%3Abg-muted%20focus-ring%22%7D"
              onClick={() => setIsMobileFilterOpen(false)}
              className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground transition-smooth hover:bg-muted focus-ring">

                <Icon data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1184:16" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1184" data-component-end-line="1184" data-component-file="BrowseProductsInteractive.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22XMarkIcon%22%7D" name="XMarkIcon" size={24} />
              </button>
            </div>
            <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1187:12" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1187" data-component-end-line="1194" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22p-4%22%7D" className="p-4">
              <FilterSidebar data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1188:14" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1188" data-component-end-line="1192" data-component-file="BrowseProductsInteractive.tsx" data-component-name="FilterSidebar" data-component-content="%7B%22elementName%22%3A%22FilterSidebar%22%7D"
              filters={filters}
              onFilterChange={handleFilterChange}
              onClearFilters={handleClearFilters}
              activeFilterCount={activeFilterCount} />

            </div>
            <div data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1195:12" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1195" data-component-end-line="1202" data-component-file="BrowseProductsInteractive.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22sticky%20bottom-0%20border-t%20border-border%20bg-card%20p-4%22%7D" className="sticky bottom-0 border-t border-border bg-card p-4">
              <button data-component-id="src/app/browse-products/components/BrowseProductsInteractive.tsx:1196:14" data-component-path="src/app/browse-products/components/BrowseProductsInteractive.tsx" data-component-line="1196" data-component-end-line="1201" data-component-file="BrowseProductsInteractive.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22w-full%20rounded-lg%20bg-primary%20px-6%20py-3%20font-semibold%20text-primary-foreground%20transition-smooth%20hover%3Abg-primary%2F90%20focus-ring%22%2C%22textContent%22%3A%22Show%20Results%22%7D"
              onClick={() => setIsMobileFilterOpen(false)}
              className="w-full rounded-lg bg-primary px-6 py-3 font-semibold text-primary-foreground transition-smooth hover:bg-primary/90 focus-ring">

                Show {filteredAndSortedProducts.length} Results
              </button>
            </div>
          </div>
        </div>
      }
    </div>);

};

export default BrowseProductsInteractive;